// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2B4Qf","toggle":"styles_toggle__3S7xr","preview":"styles_preview__-Bued"};